import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import SearchCohabitation from 'shell/components/shared/search-cohabitation';
import ActionsList from './actions';

interface ResearchCohabitationNotificationSharedProps {
  goBackUrl?: string;
  destinationUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchCohabitationNotificationShared = ({
  goBackUrl = '',
  destinationUrl = '',
  items = [],
}: ResearchCohabitationNotificationSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <SearchCohabitation
        action={ActionsList}
        goBackUrl={goBackUrl}
        destinationUrl={destinationUrl}
      />
    </Fragment>
  );
};

ResearchCohabitationNotificationShared.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationShared;
